import { render, staticRenderFns } from "./ReportingUserList.vue?vue&type=template&id=899f36ba"
import script from "./ReportingUserList.vue?vue&type=script&lang=js"
export * from "./ReportingUserList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports